import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=d033a9ce&scoped=true"
import script from "./Conference.vue?vue&type=script&lang=js"
export * from "./Conference.vue?vue&type=script&lang=js"
import style0 from "./Conference.vue?vue&type=style&index=0&id=d033a9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d033a9ce",
  null
  
)

export default component.exports